import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/DarkMode.css';
import './styles/HighlightColors.css';
import App from './App';
import { PostHogProvider } from 'posthog-js/react';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={process.env.REACT_APP_POSTHOG_KEY}
      options={{
        api_host: process.env.REACT_APP_POSTHOG_HOST,
        debug: process.env.NODE_ENV === 'development',
        // Disable auto pageview tracking; PageviewTracker in App.js fires $pageview
        // on every React Router location change so we control the URL we capture
        // and can also emit virtual pageviews when OS windows open.
        capture_pageview: false,
      }}
    >
      <App />
    </PostHogProvider>
  </React.StrictMode>
);

reportWebVitals();